export default "__VITE_ASSET__DQ$fEFIO__"